import isFunction from 'lodash/isFunction';

import { getGa } from 'core/googleAnalytics';

type EventCategory = 'CAMPAIGNS';

type EventAction =
  | 'NEW_CAMPAIGN'
  | 'CHOOSE_CAMPAIGN_NO_DELIVERY_FEE'
  | 'CHOOSE_CAMPAIGN_ORDER_VALUE_DISCOUNT'
  | 'CHOOSE_CAMPAIGN_ITEM_PROMOTIONS'
  | 'CHOOSE_CAMPAIGN_ADS'
  | 'CHOOSE_CAMPAIGN_GET_STARTED'
  | 'CHOOSE_CAMPAIGN_CANCEL'
  | 'NEW_AD_CAMPAIGN_WEEKLY_BUDGET_BUTTON'
  | 'NEW_AD_CAMPAIGN_EDIT_SCHEDULE_BUTTON'
  | 'NEW_AD_CAMPAIGN_TC_ACCEPTANCE'
  | 'NEW_AD_CAMPAIGN_CREATE_CAMPAIGN';

type ReportPayload = {
  hitType: 'event';
  eventCategory: EventCategory;
  eventAction: EventAction;
};

const report = (payload: ReportPayload) => {
  const ga = getGa();

  if (!isFunction(ga)) {
    return;
  }

  ga('send', payload);
};

export const reportEvent = (eventAction: EventAction) => {
  report({
    hitType: 'event',
    eventCategory: 'CAMPAIGNS',
    eventAction,
  });
};
